import { render, staticRenderFns } from "./HiFooter.vue?vue&type=template&id=12f644ff&scoped=true&"
import script from "./HiFooter.vue?vue&type=script&lang=js&"
export * from "./HiFooter.vue?vue&type=script&lang=js&"
import style0 from "./HiFooter.vue?vue&type=style&index=0&id=12f644ff&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f644ff",
  null
  
)

export default component.exports